import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { HeaderService } from '../fuse/services/header-service';

@Component({
    selector: 'app-doctors-view',
    templateUrl: './doctors-view.component.html',
    styleUrls: ['./doctors-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class DoctorsViewComponent implements OnInit {

  constructor(public headerService: HeaderService) { }

  ngOnInit() {
  }

}
 